import React from 'react';
import { Title } from '@landing/ui';
import MobileSlider from './MobileSlider';
import ScrollSlider from './ScrollSlider';
import { useWindowResize } from 'utils/hooks';
import { projects } from 'define/projects';

import * as styles from './Projects.module.scss';

export default function Projects({ title }) {
  const { width } = useWindowResize();

  return (
    <section id="projects" className={styles.container}>
      <div className={styles.layout}>
        <Title className={styles.title} color="white">
          {title}
        </Title>
      </div>
      <div className={styles.sliderWrapper}>
        {width < 1025 ? (
          <MobileSlider id="projects-slider" items={projects} />
        ) : (
          <ScrollSlider projects={projects} />
        )}
      </div>
    </section>
  );
}
